import React from "react";
import { FaFileContract } from "react-icons/fa";
import "./TermsConditions.css";

const TermsConditions = () => {
  return (
    <section className="terms-box-container">
      <div className="terms-box">
        <FaFileContract className="terms-icon" />
        <h1 className="terms-title">Términos y Condiciones</h1>

        <div className="terms-content">
          <p>
            Al enviar este formulario, el usuario acepta los siguientes términos:
          </p>

          <h3>1. Uso de la Información</h3>
          <p>
            La información personal proporcionada será utilizada exclusivamente por Thorne Global
            y empresas del grupo para brindar asesoramiento sobre oportunidades de inversión,
            enviar información comercial o responder consultas.
          </p>

          <h3>2. Privacidad y Protección de Datos</h3>
          <p>
            Nos comprometemos a proteger su información. Los datos no serán vendidos ni compartidos
            con terceros ajenos al grupo empresarial sin su consentimiento, salvo por obligación legal.
          </p>

          <h3>3. Contenido Informativo</h3>
          <p>
            Toda la información brindada en esta página es de carácter informativo y no constituye
            una oferta legal vinculante ni asesoramiento financiero. Thorne Global no se responsabiliza
            por decisiones tomadas en base al contenido publicado.
          </p>

          <h3>4. Cambios en los Términos</h3>
          <p>
            Estos términos pueden ser actualizados sin previo aviso. Se recomienda revisarlos periódicamente.
          </p>
        </div>
      </div>
    </section>
  );
};

export default TermsConditions;